import React from "react";
import { RouteProps, Redirect, Route } from "react-router-dom";

import { useSession } from "../SessionManager";

const AuthenticatedRoute: React.FunctionComponent<RouteProps> = ({
  children,
  ...props
}) => {
  const session = useSession();

  return (
    <Route
      {...props}
      render={({ location }) =>
        !session.isSignedIn ? (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        ) : (
          children
        )
      }
    />
  );
};

export default AuthenticatedRoute;
